import { fetchAuthenticatedJson } from './authenticatedFetch';

function buildQuery(params = {}) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    query.set(key, value);
  });
  const queryString = query.toString();
  return queryString ? `?${queryString}` : '';
}

export function fetchLiveTradingStatsSummary(filters = {}) {
  return fetchAuthenticatedJson(`/api/admin/trading/live-stats/summary${buildQuery(filters)}`);
}

export function fetchLiveTradingStatsTrades(filters = {}) {
  return fetchAuthenticatedJson(`/api/admin/trading/live-stats/trades${buildQuery(filters)}`);
}

export function fetchLiveTradingStatsTradeDetail(intentId) {
  return fetchAuthenticatedJson(`/api/admin/trading/live-stats/trades/${intentId}`);
}

export function fetchLiveTradingStatsTakeProfits(filters = {}) {
  return fetchAuthenticatedJson(`/api/admin/trading/live-stats/take-profits${buildQuery(filters)}`);
}

export function fetchLiveTradingStatsHistory(filters = {}) {
  return fetchAuthenticatedJson(`/api/admin/trading/live-stats/history${buildQuery(filters)}`);
}
